export const visualizationAccessible = {
    visualizationOne: {
        base: "#00997B",
        contrast: "#00614E",
        gradient: "#00A887",
        highlight: "#B8FFF1",
        hint: "#E8EDFD",
        inverseContainer: "#00614E"
    },
    visualizationTwo: {
        base: "#313FC4",
        contrast: "#192166",
        gradient: "#3442CC",
        highlight: "#C6CAF1",
        hint: "#E7E8F9"
    },
    visualizationThree: {
        base: "#0A8EFF",
        contrast: "#00427A",
        gradient: "#1F98FF",
        highlight: "#B8DEFF",
        hint: "#E5F3FF",
        inverseContainer: "#0058A3"
    },
    visualizationFour: {
        base: "#D62939",
        contrast: "#67141B",
        gradient: "#D83645",
        highlight: "#F4C3C8",
        hint: "#FAE5E7",
        inverseContainer: "#AB212E"
    },
    visualizationFive: {
        base: "#BF57FF",
        contrast: "#4C007A",
        gradient: "#C76BFF",
        highlight: "#E4B8FF",
        hint: "#F3E0FF",
        inverseContainer: "#8500D6"
    },
    visualizationSix: {
        base: "#207F3B",
        contrast: "#155126",
        gradient: "#259344",
        highlight: "#C6F1D2",
        hint: "#E7F9EC",
        inverseContainer: "#1A662F"
    },
    visualizationSeven: {
        base: "#CC6900",
        contrast: "#753C00",
        gradient: "#DF7A0B",
        highlight: "#FFD7AD",
        hint: "#FFEEDB"
    },
    visualizationEight: {
        base: "#1A52FF",
        contrast: "#001F80",
        gradient: "#3365FF",
        highlight: "#B8C9FF",
        hint: "#E0E8FF"
    },
    visualizationNine: {
        base: "#DA4C95",
        contrast: "#65153E",
        gradient: "#DE5EA0",
        highlight: "#F1BBD7",
        hint: "#F9E1ED"
    }
};
export const visualizationAccessibleThemeOverrides = {
    features: {
        enhancedVisualizationContrast: true
    },
    colorSchemes: {
        alchemyLight: {
            ...visualizationAccessible
        },
        alchemyDark: {
            ...visualizationAccessible
        },
        alchemyPanel: {
            ...visualizationAccessible
        },
        alchemyBrand: {
            ...visualizationAccessible
        }
    }
};
